"use strict";

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var rich_text_types_1 = require("@contentful/rich-text-types");

var RichTextRenderer_1 = require("../RichTextRenderer/RichTextRenderer");

var util_1 = require("../RichTextRenderer/renderers/util");

var FootnoteRenderer_1 = require("../RichTextRenderer/renderers/entry-item/FootnoteRenderer");

var util_2 = require("../RichTextRenderer/renderers/entry-item/util");

exports.FootnotesRichtextRenderer = function (_a) {
  var _b;

  var content = _a.content,
      wrapper = _a.wrapper,
      _c = _a.wrapperOptions,
      wrapperOptions = _c === void 0 ? {} : _c;
  console.warn('[lws-react-components] FootnotesRichtextRenderer is deprecated. Please use ContentfulRichTextRenderer and configure it properly through rendering options.');

  if (!content) {
    return null;
  }

  var rendererOptions = {
    renderNode: (_b = {}, _b[rich_text_types_1.BLOCKS.PARAGRAPH] = util_1.createSimpleComponentRendererFor(wrapper, wrapperOptions), _b[rich_text_types_1.INLINES.EMBEDDED_ENTRY] = util_2.composeEntryLinkRendererUsing({
      Footnote: FootnoteRenderer_1.renderFootnote
    }), _b)
  };
  return react_1["default"].createElement(RichTextRenderer_1.ContentfulRichTextRenderer, {
    content: content,
    options: rendererOptions
  });
};